import axios from 'axios'
import {BUSCAR_PLATAFORMAS} from '../types'
import {SLOW_REQUEST_CONFIG} from '../../util/loadingUtil'
import {URL} from '../../util/ambienteActions';

export default function buscarPlataformas() {
    const url = `${URL}/plataformas/web`;
    return dispatch => axios.get(url, SLOW_REQUEST_CONFIG).then(
        response => dispatch({
            type: BUSCAR_PLATAFORMAS,
            payload: response

        })
    );
}
